import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { dashboard } from "../../references/link";
import "./Header.css";
// import {IoInformationSharp} from "react-icons/io5";
import i from "../../ressources/images/i.svg";
import { LanguageContext } from "../../LanguageContext";
import InfoPopup from "./InfoPopup";
import DAY from "../../ressources/images/dayW.svg";
import MOIS from "../../ressources/images/moisW.svg";
import WEEK from "../../ressources/images/weekW.svg";
import YEAR from "../../ressources/images/yearW.svg";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import { isInIframe } from "../../App";

const Header = (props: {
  activeTab: string;
  titre: string | React.JSX.Element;
  changementDOngletFrequence: (arg: number) => void;
  ongletFrequence: number;
}) => {
  const { translations } = useContext(LanguageContext);

  const [isPopupVisible, setIsPopupVisible] = useState(false);

  const togglePopup = () => {
    setIsPopupVisible(!isPopupVisible);
  };
  const { changementDOngletFrequence, ongletFrequence } = props;
  const sizeOfIcons = 35;

  return (
    <div className="header">
      {!isInIframe && (
        <div className="sensor-header">
          <div className="sensor-header-item">
            <img
              src={i}
              style={{ width: `${sizeOfIcons * 0.9}px` }}
              alt={translations["icon information"]}
              onClick={togglePopup}
            />
          </div>
          <div className="sensor-header-item">
            <h2 className="header-title-text">{props.titre}</h2>
          </div>
          <div className="sensor-header-item">
            <CancelOutlinedIcon
              style={{ color: "#a6163f", fontSize: `${sizeOfIcons}px` }}
            />
            <Link
              to={`/${dashboard}`}
              aria-label="close-icon"
              style={{
                height: sizeOfIcons,
                width: sizeOfIcons,
                position: "absolute",
              }}
            ></Link>
          </div>
        </div>
      )}
      <div className="header-buttons">
        <button
          onClick={() => changementDOngletFrequence(0)}
          className={
            ongletFrequence === 0
              ? "action-button active"
              : "action-button req-button"
          }
        >
          <img
            className={"icon-periode marg"}
            src={DAY}
            alt={translations["icon de jour marg"]}
          />
        </button>
        <button
          onClick={() => changementDOngletFrequence(1)}
          className={
            ongletFrequence === 1
              ? "action-button active"
              : "action-button req-button"
          }
        >
          <img
            className={"icon-periode marg"}
            src={WEEK}
            alt={translations["icon de semaine marg"]}
          />
        </button>
        <button
          onClick={() => changementDOngletFrequence(2)}
          className={
            ongletFrequence === 2
              ? "action-button active"
              : "action-button req-button"
          }
        >
          <img
            className={"icon-periode marg"}
            src={MOIS}
            alt={translations["icon de mois marg"]}
          />
        </button>
        <button
          onClick={() => changementDOngletFrequence(3)}
          className={
            ongletFrequence === 3
              ? "action-button active last"
              : "action-button req-button last"
          }
        >
          <img
            className={"icon-periode marg"}
            src={YEAR}
            alt={translations["icon de années marg"]}
          />
        </button>
      </div>
      {isPopupVisible && (
        <>
          <div className="modal-backdrop" onClick={togglePopup} />
          <InfoPopup activeTab={props.activeTab} togglePopup={togglePopup} />
        </>
      )}
    </div>
  );
};

export default Header;
